module.exports = __webpack_public_path__ + "img/map-img-complete-blur-sm.9b50e7ba.webp";